var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"echarts-waterfall-chart",attrs:{"role":"img","aria-label":_vm.ariaLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }